import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import UserGrid from '../../_partials/UserGrid';

export interface Props {
  moduleId: number;
  seeAllUrl: string;
  browseUrl: string;
  username: string;
  deviants: PapiUser[];
  isHeaderStickyOnMobile?: boolean;
}

export const UserStream: React.FC<Props> = ({ deviants }) => {
  return <UserGrid users={deviants} />;
};

export default UserStream;
